import { HostedNumberOrderResponse } from '../types';

export enum OrderStatus {
  'failed',
  'pending',
  'in_progress',
  'successful',
}

export type HostedNumberStatus = 'deleted' | 'failed' | 'failed_activation' | 'failed_carrier_rejected' | 'failed_ineligible_carrier' | 'failed_number_already_hosted' | 'failed_number_not_found' | 'failed_ownership_verification' | 'failed_timeout' | 'ownership_successful' | 'pending' | 'provisioning' | 'successful';
export type HostedNumberOrderStatus = 'carrier_rejected' | 'compliance_review_failed' | 'deleted' | 'failed' | 'incomplete_documentation' | 'incorrect_billing_information' | 'ineligible_carrier' | 'loa_file_invalid' | 'loa_file_successful' | 'pending' | 'provisioning' | 'successful';


export const calculateStatusAndDescription = (order: HostedNumberOrderResponse | undefined, phoneNumber: string): { status: OrderStatus, description: string } => {
  if (order == null) {
    return { status: OrderStatus.pending, description: 'Setup phone number' };
  }
  
  const phoneOrderStatus = order.phoneNumbers.find(pn => pn.phoneNumber === phoneNumber);

  const orderDescription = `Order status: ${order.detail ?? ''} (${order.status})`;
  const phoneOrderDescription = phoneOrderStatus != null ? `\nPhone number status: ${phoneOrderStatus?.detail ?? ''} (${phoneOrderStatus?.status})` : '';

  const description = `${orderDescription}${phoneOrderDescription}`;


  const failedOrderStatuses = ['carrier_rejected',
    'compliance_review_failed',
    'failed',
    'incomplete_documentation',
    'incorrect_billing_information',
    'ineligible_carrier',
    'loa_file_invalid',];
  const isFailed = failedOrderStatuses.includes(order?.status || '') || failedOrderStatuses.includes(phoneOrderStatus?.status || '');

  let status = OrderStatus.pending;
  if (isFailed) {
    status = OrderStatus.failed;
  } else if (order.status === 'successful' && phoneOrderStatus?.status === 'successful') {
        status = OrderStatus.successful;
  } else if (order.status === 'pending') {
    status = OrderStatus.pending;
  } else {
    status = OrderStatus.in_progress;
  }

  return { status, description };
};